import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Namespace } from '../../../../translation/namespace';
import { SVG, Icons } from '../../../../components/atoms/SVG';
import { Tooltip, TooltipPlacement } from '../../../../components/atoms/Tooltip';

export type KeywordDeletableProps = {
  name: string;
  onClick: () => void;
};

export default function KeywordDeletable({ name, onClick }: KeywordDeletableProps) {
  const { t } = useTranslation(Namespace.Keywords);

  const buttonRef = useRef<HTMLButtonElement>(null);
  const deleteButtonTitle = t('form.deleteButton', { keyword: name });

  return (
    <>
      <span className="keywords__text keywords__text--button font-regular-13-13">{name}</span>
      <Tooltip attachTo={buttonRef} placement={TooltipPlacement.TOP}>
        <button ref={buttonRef} onClick={onClick} type="button" className="keywords__button" title={deleteButtonTitle}>
          <SVG svgSpriteId={Icons.DELETE_X_SMALL} svgClass="keywords__svg" />
          <span className="invisible">{deleteButtonTitle}</span>
        </button>
      </Tooltip>
    </>
  );
}
